import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import releaseNotes from "./../../assets/release.notes.md";
import "./style.scss";

// Use div for paragraph to avoid invalid DOM nesting (<p> inside <p>) which causes console errors
const renderers = {
  paragraph: ({ children }) => <div className="release-notes-p">{children}</div>,
};

export default () => {
  const [file, setFile] = useState();

  useEffect(() => {
    fetch(releaseNotes)
      .then((response) => response.text())
      .then((text) => setFile(text));
  }, []);

  if (!file) {
    return (
      <div className="release-notes-page">
        <div className="release-notes-content">Loading release notes…</div>
      </div>
    );
  }

  return (
    <div className="release-notes-page">
      <article className="release-notes-content">
        <ReactMarkdown renderers={renderers}>{file}</ReactMarkdown>
      </article>
    </div>
  );
};
